module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }